/* BRAND BOOK · Tuchkarte · Farbkarte als Tuchbuch (Vorschau T1, 25.09.2026)
   Jede Farbe ist ein Knopf im Mosaik. Zeigen (Maus) laesst das Tuch auf der Buehne probehalber erscheinen,
   Waehlen (Klick, Tastatur) setzt es. Name und Artikelnummer stehen unter der Buehne.
   Ohne Skript bleibt das Porträt stehen; jede Farbe traegt Name und Nummer als Beschriftung (aria-label, title). */
(function () {
  var karten = document.querySelectorAll('[data-bb-karte]');
  if (!karten.length) return;
  var zeigbar = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  // Handy: Farbkarte aufklappen (uebliche Farben und Black zuerst, Rest ueber „Alle … Farben“)
  Array.prototype.forEach.call(document.querySelectorAll('.bb-fk-mehr'), function (knopf) {
    var feld = document.getElementById(knopf.getAttribute('aria-controls'));
    if (!feld) return;
    knopf.addEventListener('click', function () {
      var auf = knopf.getAttribute('aria-expanded') !== 'true';
      feld.classList.toggle('ist-offen', auf);
      knopf.setAttribute('aria-expanded', String(auf));
      knopf.textContent = knopf.getAttribute(auf ? 'data-zu' : 'data-auf');
    });
  });
  Array.prototype.forEach.call(karten, function (karte) {
    var buehne = karte.querySelector('[data-bb-buehne-tuch]');
    var bild = buehne && buehne.querySelector(':scope > img');
    var jetzt = karte.querySelector('[data-bb-jetzt]');
    var chips = karte.querySelectorAll('.bb-chip');
    if (!bild || !jetzt || !chips.length) return;
    var vorlage = karte.getAttribute('data-alt-vorlage') || '{haus} {tuch}, {name} ({nr})';
    var ursprung = { src: bild.getAttribute('src'), srcset: bild.getAttribute('srcset'), alt: bild.getAttribute('alt') };
    var start = karte.querySelector('.bb-chip[aria-pressed="true"]');
    var gewaehlt = start;
    var nameEl = jetzt.querySelector('.bb-jetzt__name'), nrEl = jetzt.querySelector('.bb-jetzt__nr'), ueEl = jetzt.querySelector('.bb-jetzt__ueblich');
    function zeige(chip) {
      if (!chip) return;
      if (chip === start) { bild.setAttribute('src', ursprung.src); if (ursprung.srcset) bild.setAttribute('srcset', ursprung.srcset); bild.setAttribute('alt', ursprung.alt); }
      else {
        bild.setAttribute('srcset', chip.getAttribute('data-srcset'));
        bild.setAttribute('src', chip.getAttribute('data-src'));
        bild.setAttribute('alt', vorlage.replace('{haus}', karte.getAttribute('data-haus')).replace('{tuch}', karte.getAttribute('data-tuch')).replace('{name}', chip.getAttribute('data-name')).replace('{nr}', chip.getAttribute('data-nr')));
      }
      nameEl.textContent = chip.getAttribute('data-name');
      nrEl.textContent = chip.getAttribute('data-nr');
      if (ueEl) ueEl.hidden = chip.getAttribute('data-ueblich') !== '1';
    }
    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        if (gewaehlt) gewaehlt.setAttribute('aria-pressed', 'false');
        chip.setAttribute('aria-pressed', 'true'); gewaehlt = chip; zeige(chip);
      });
      if (zeigbar) {
        chip.addEventListener('mouseenter', function () { zeige(chip); });
        chip.addEventListener('focus', function () { zeige(chip); });
      }
    });
    if (zeigbar) {
      var feld = karte.querySelector('.bb-chips');
      feld.addEventListener('mouseleave', function () { zeige(gewaehlt); });
      feld.addEventListener('focusout', function (e) { if (!feld.contains(e.relatedTarget)) zeige(gewaehlt); });
    }
  });
})();
